import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hotjar': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M414.9 161.5c30 53 41.8 121.6 26.3 180.9-14.7 56.7-68.3 120.3-148.8 145.6 54.5-76.9 43.9-200.1-27.1-215.5 54.2 93.9-53.7 180.3-110.8 93.9-2.5 7.2-25.1 74.5 4.1 129.6-61.1-9.1-117.8-33.5-144.6-93.4-35-78.2-2.7-149.8 79-204.9 129.2-87.3 28.1-197.7 28.1-197.7s219.1 29 293.8 161.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hotjar.js
// module id = 881
// module chunks = 0